import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import translations from '../data/translations';

const WhatsAppButton = () => {
  const { lang } = useLang();
  const message = translations[lang].whatsapp.message;
  const whatsappUrl = `https://wa.me/351915220443?text=${message}`;

  const handleClick = (e) => {
    e.preventDefault();
    try {
      const top = window.top || window;
      top.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    } catch {
      window.location.href = whatsappUrl;
    }
  };

  return (
    <div className="fixed bottom-8 left-6 z-[9999]" data-testid="whatsapp-wrapper">
      <button
        onClick={handleClick}
        className="bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-3.5 shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-110 flex items-center justify-center cursor-pointer"
        aria-label="WhatsApp"
        data-testid="whatsapp-button"
      >
        <MessageCircle className="w-5 h-5" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
